import axios from 'axios';
import { handleRequest } from 'helpers/api';
import { VendorDetails } from 'redux-state/user/vendorSlice';
import { CustomerAddress } from './customer_requests';

const VENDOR_URL = `${process.env.REACT_APP_API_URL}/vendor`;

const vendorApi = axios.create({
  baseURL: VENDOR_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

export interface VendorProfileUpdate {
  email?: string;
  fullName?: string;
  phone: string;
  address: CustomerAddress;
}

export interface Vendor {
  _id?: string;
  fullName: string;
  avatar: string | null;
}

export interface VendorDetailSingle {
  fullName: string;
  email: string;
  phone: string;
  address: CustomerAddress;
  totalOrders: number;
  totalRevenue: number;
  lastOrderDate: string | null;
  createdAt: string | null;
  userId: UserInfo;
  productsCount: number;
  totalReviews: number;
  totalRatings: number;
  averageRating: number;
  totalRankings: number;
}

export interface UserInfo {
  id: string;
  fullName: string;
  email: string;
  avatar: string | null;
  role: 'vendor' | 'customer';
  createdAt: string;
  updatedAt: string;
}

export interface addVendorReview {
  Id: string;
  rating: number;
  review: string;
  userId: string;
}

export const getVendorDetails = async () => {
  return handleRequest(vendorApi.get<VendorDetails>('/details'));
};

export const getAllVendors = async () => {
  return handleRequest(vendorApi.get<Vendor[]>('/allvendors'));
};

export const getVendorDetailsById = async (id: string) => {
  return handleRequest(
    vendorApi.get<VendorDetailSingle>(`/vendor-by-id/${id}`)
  );
};

export const getAllProductByVendor = async (id: string) => {
  return handleRequest(
    vendorApi.get<{ count: number }>(`/all-product-by-vendorId/${id}`)
  );
};

export const updateVendorDetails = async (data: VendorProfileUpdate) => {
  return handleRequest(vendorApi.put<VendorProfileUpdate>('/profile', data));
};

export const getVendorById = async () => {
  return handleRequest(vendorApi.get<VendorProfileUpdate>('/details'));
};

export const addVendorReview = async (vendorReview: addVendorReview) => {
  return handleRequest(vendorApi.post('/addVendorReview', vendorReview));
};
